/**
 * Shared formatting helpers for the SuperAdmin Platform pages
 * (Daily PnL tab + User Roster tab). Kept in utils/ so both tabs
 * import the same definitions and any tweak (digit count, sign
 * convention, color tone) propagates everywhere consistently.
 */

export function formatInr(value: number | null | undefined): string {
  if (value == null) return '—';
  const sign = value < 0 ? '-' : '';
  return `${sign}₹${Math.abs(value).toLocaleString('en-IN', { maximumFractionDigits: 2 })}`;
}

export function formatPct(value: number | null | undefined, digits = 2): string {
  if (value == null) return '—';
  return `${value.toFixed(digits)}%`;
}

/** Tailwind class for positive / negative / neutral P&L rendering. */
export function pnlClass(value: number): string {
  if (value > 0) return 'text-green-600 dark:text-green-400';
  if (value < 0) return 'text-red-600 dark:text-red-400';
  return 'text-gray-600 dark:text-gray-300';
}

/** YYYY-MM-DD for today in IST. Used for clamping date pickers (no future dates). */
export function istCalendarToday(): string {
  const IST_OFFSET_MS = (5 * 60 + 30) * 60_000;
  return new Date(Date.now() + IST_OFFSET_MS).toISOString().slice(0, 10);
}
